import {types as origTypes} from "mobx-state-tree";
import {dateType} from "./types/Date";
import {bigDecimalType} from "./types/BigDecimal.ts";

export const types = {...origTypes, Date: dateType, BigDecimal: bigDecimalType};
